import React, { useContext, useEffect, useState } from "react";
import "./Sidebar.css";
import { Nav, Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GiCardPlay, GiPokerHand } from "react-icons/gi";
import {
  faAdjust,
  faAnglesDown,
  faAnglesRight,
  faBell,
  faBug,
  faBus,
  faCog,
  faDice,
  faGamepad,
  faGauge,
  faGear,
  faHandHoldingHand,
  faLeaf,
  faLocationDot,
  faPeopleArrows,
  faPerson,
  faTicket,
  faTint,
  faTShirt,
  faUserTie,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Context, isAllow } from "../../utils/context";
import { findAllSideBar } from "../../utils/apis/dashboard/dashboard";
import { faWordpress } from "@fortawesome/free-brands-svg-icons";

function Sidebar() {
  const { usertype, isAllow } = useContext(Context);
  const location = useLocation();

  const [activeLink, setActiveLink] = useState(location.pathname);
  const [activeKey, setActiveKey] = useState("0"); // Controls which accordion is open

  const handleNavClick = (path) => {
    setActiveLink(path);
  };

  const { UnauthorizedLogOut } = useContext(Context);
  const [data, setData] = useState([]);

  const getDataAll = async () => {
    // try {
    //   const response = await findAllSideBar();
    //   await setData(response?.data?.data);
    // } catch (error) {
    //   console.error(error.message);
    //   await UnauthorizedLogOut(error);
    // }
  };

  useEffect(() => {
    getDataAll();
    const intervalId = setInterval(() => {
      getDataAll();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  // Auto set active accordion based on current route
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  return (
    <section className="Sidebar">
      <Nav className="sidebar-link-holder">
        <Nav.Link
          className={activeLink === "/dashboard" ? "active" : ""}
          onClick={() => handleNavClick("/dashboard")}
          as={Link}
          to={"/dashboard"}>
          <FontAwesomeIcon icon={faGauge} className="me-2" />
          Dashboard
        </Nav.Link>

        {/* Roles */}
        {/* {isAllow?.includes(1) ||
        isAllow?.includes(2) ||
        isAllow?.includes(3) ||
        isAllow?.includes(4) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="0">
              <Accordion.Header onClick={() => handleNavClick("/master")}>
                <FontAwesomeIcon icon={faUserTie} className="me-2" />
                Roles
              </Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={
                    activeLink === "/role-management/roles" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/role-management/roles")}
                  as={Link}
                  to={"/role-management/roles"}>
                  Roles
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )} */}

        {/* Master */}
        {isAllow?.includes(5) ||
        isAllow?.includes(6) ||
        isAllow?.includes(7) ||
        isAllow?.includes(8) ||
        isAllow?.includes(9) ||
        isAllow?.includes(10) ||
        isAllow?.includes(11) ||
        isAllow?.includes(12) ||
        isAllow?.includes(13) ||
        isAllow?.includes(14) ||
        isAllow?.includes(15) ||
        isAllow?.includes(16) ||
        isAllow?.includes(17) ||
        isAllow?.includes(18) ||
        isAllow?.includes(19) ||
        isAllow?.includes(20) ||
        isAllow?.includes(21) ||
        isAllow?.includes(22) ||
        isAllow?.includes(23) ||
        isAllow?.includes(24) ||
        isAllow?.includes(25) ||
        isAllow?.includes(26) ||
        isAllow?.includes(27) ||
        isAllow?.includes(28) ||
        isAllow?.includes(29) ||
        isAllow?.includes(30) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="1">
              <Accordion.Header onClick={() => handleNavClick("/master")}>
                <FontAwesomeIcon icon={faAdjust} className="me-2" />
                Master
              </Accordion.Header>
              <Accordion.Body>
                {isAllow?.includes(5) ||
                isAllow?.includes(6) ||
                isAllow?.includes(7) ||
                isAllow?.includes(8) ? (
                  <Nav.Link
                    className={activeLink === "/banners" ? "active" : ""}
                    onClick={() => handleNavClick("/banners")}
                    as={Link}
                    to={"/banners"}>
                    Banners
                  </Nav.Link>
                ) : (
                  <></>
                )}
                {/* {isAllow?.includes(9) ||
                isAllow?.includes(10) ||
                isAllow?.includes(11) ||
                isAllow?.includes(12) ? (
                  <Nav.Link
                    className={activeLink === "/avatars" ? "active" : ""}
                    onClick={() => handleNavClick("/avatars")}
                    as={Link}
                    to={"/avatars"}>
                    Avatars
                  </Nav.Link>
                ) : (
                  <></>
                )} */}
                {/* {isAllow?.includes(13) ||
                isAllow?.includes(14) ||
                isAllow?.includes(15) ||
                isAllow?.includes(16) ? (
                  <Nav.Link
                    className={activeLink === "/country" ? "active" : ""}
                    onClick={() => handleNavClick("/country")}
                    as={Link}
                    to={"/country"}>
                    Country
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(17) ||
                isAllow?.includes(18) ||
                isAllow?.includes(19) ||
                isAllow?.includes(20) ? (
                  <Nav.Link
                    className={activeLink === "/state" ? "active" : ""}
                    onClick={() => handleNavClick("/state")}
                    as={Link}
                    to={"/state"}>
                    State
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(21) ||
                isAllow?.includes(22) ||
                isAllow?.includes(23) ||
                isAllow?.includes(24) ? (
                  <Nav.Link
                    className={activeLink === "/city" ? "active" : ""}
                    onClick={() => handleNavClick("/city")}
                    as={Link}
                    to={"/city"}>
                    City
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(25) ||
                isAllow?.includes(26) ||
                isAllow?.includes(27) ||
                isAllow?.includes(28) ? (
                  <Nav.Link
                    className={activeLink === "/pincode" ? "active" : ""}
                    onClick={() => handleNavClick("/pincode")}
                    as={Link}
                    to={"/pincode"}>
                    Pincode
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}*/}
                {isAllow?.includes(29) || isAllow?.includes(30) ? (
                  <Nav.Link
                    className={activeLink === "/policy" ? "active" : ""}
                    onClick={() => handleNavClick("/policy")}
                    as={Link}
                    to={"/policy"}>
                    Policy
                  </Nav.Link>
                ) : (
                  <></>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )}
        {isAllow?.includes(31) || isAllow?.includes(32) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="2">
              <Accordion.Header onClick={() => handleNavClick("/master")}>
                <FontAwesomeIcon icon={faGear} className="me-2" />
                App Setup
              </Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeLink === "/app-setup" ? "active" : ""}
                  onClick={() => handleNavClick("/app-setup")}
                  as={Link}
                  to={"/app-setup"}>
                  App Set Up
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )}

        {isAllow?.includes(33) ||
        isAllow?.includes(34) ||
        isAllow?.includes(35) ||
        isAllow?.includes(36) ||
        isAllow?.includes(37) ||
        isAllow?.includes(38) ||
        isAllow?.includes(39) ||
        isAllow?.includes(40) ||
        isAllow?.includes(41) ||
        isAllow?.includes(42) ||
        isAllow?.includes(43) ||
        isAllow?.includes(44) ||
        isAllow?.includes(45) ||
        isAllow?.includes(46) ||
        isAllow?.includes(47) ||
        isAllow?.includes(48) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="3">
              <Accordion.Header onClick={() => handleNavClick("/customer")}>
                <FontAwesomeIcon icon={faPeopleArrows} className="me-2" />
                User Management
              </Accordion.Header>

              <Accordion.Body>
                {/* {isAllow?.includes(33) ||
                isAllow?.includes(34) ||
                isAllow?.includes(35) ||
                isAllow?.includes(36) ? (
                  <Nav.Link
                    className={
                      activeLink === "/agent-management/super-super-master"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleNavClick("/agent-management/super-super-master")
                    }
                    as={Link}
                    to={"/agent-management/super-super-master"}>
                    Super Super Master
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "} */}
                {/* {isAllow?.includes(37) ||
                isAllow?.includes(38) ||
                isAllow?.includes(39) ||
                isAllow?.includes(40) ? (
                  <Nav.Link
                    className={
                      activeLink === "/agent-management/super-master"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleNavClick("/agent-management/super-master")
                    }
                    as={Link}
                    to={"/agent-management/super-master"}>
                    Super Master
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(41) ||
                isAllow?.includes(42) ||
                isAllow?.includes(34) ||
                isAllow?.includes(44) ? (
                  <Nav.Link
                    className={
                      activeLink === "/agent-management/master" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/agent-management/master")}
                    as={Link}
                    to={"/agent-management/master"}>
                    Master
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "} */}
                {isAllow?.includes(45) ||
                isAllow?.includes(46) ||
                isAllow?.includes(47) ||
                isAllow?.includes(48) ? (
                  <Nav.Link
                    className={
                      activeLink === "/agent-management/customer"
                        ? "active"
                        : ""
                    }
                    onClick={() => handleNavClick("/agent-management/customer")}
                    as={Link}
                    to={"/agent-management/customer"}>
                    Customer
                  </Nav.Link>
                ) : (
                  <></>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )}
        {isAllow?.includes(49) ||
        isAllow?.includes(50) ||
        isAllow?.includes(51) ||
        isAllow?.includes(52) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="4">
              <Accordion.Header
                onClick={() => handleNavClick("/notifications")}>
                <FontAwesomeIcon icon={faBell} className="me-2" />
                Notifications
              </Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeLink === "/notifications" ? "active" : ""}
                  onClick={() => handleNavClick("/notifications")}
                  as={Link}
                  to={"/notifications"}>
                  Notifications
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )}

        {isAllow?.includes(53) ||
        isAllow?.includes(54) ||
        isAllow?.includes(55) ||
        isAllow?.includes(56) ||
        isAllow?.includes(57) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="5">
              <Accordion.Header onClick={() => handleNavClick("/wallet")}>
                <FontAwesomeIcon icon={faWallet} className="me-2" />
                Wallet Management
              </Accordion.Header>
              <Accordion.Body>
                {isAllow?.includes(53) ? (
                  <Nav.Link
                    className={activeLink === "/wallet/history" ? "active" : ""}
                    onClick={() => handleNavClick("/wallet/history")}
                    as={Link}
                    to={"/wallet/history"}>
                    Wallet History
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(53) ? (
                  <Nav.Link
                    className={
                      activeLink === "/wallet/deposit-request" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/wallet/deposit-request")}
                    as={Link}
                    to={"/wallet/deposit-request"}>
                    Deposit Request
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(53) ? (
                  <Nav.Link
                    className={
                      activeLink === "/wallet/deposit-accept" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/wallet/deposit-accept")}
                    as={Link}
                    to={"/wallet/deposit-accept"}>
                    Deposit Accepted
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(53) ? (
                  <Nav.Link
                    className={
                      activeLink === "/wallet/deposit-rejected" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/wallet/deposit-rejected")}
                    as={Link}
                    to={"/wallet/deposit-rejected"}>
                    Deposit Rejected
                  </Nav.Link>
                ) : (
                  <></>
                )}
                {isAllow?.includes(54) || isAllow?.includes(55) ? (
                  <Nav.Link
                    className={activeLink === "/wallet/request" ? "active" : ""}
                    onClick={() => handleNavClick("/wallet/request")}
                    as={Link}
                    to={"/wallet/request"}>
                    Wallet Requested
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(56) ? (
                  <Nav.Link
                    className={activeLink === "/wallet/accept" ? "active" : ""}
                    onClick={() => handleNavClick("/wallet/accept")}
                    as={Link}
                    to={"/wallet/accept"}>
                    Wallet Accepted
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(57) ? (
                  <Nav.Link
                    className={
                      activeLink === "/wallet/rejected" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/wallet/rejected")}
                    as={Link}
                    to={"/wallet/rejected"}>
                    Wallet Rejected
                  </Nav.Link>
                ) : (
                  <></>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )}

        {/* {isAllow?.includes(58) || isAllow?.includes(59) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="6">
              <Accordion.Header
                onClick={() => handleNavClick("/notifications")}>
                <FontAwesomeIcon icon={faDice} className="me-2" />
                Matka Management
              </Accordion.Header>

              <Accordion.Body>
                {isAllow?.includes(58) ? (
                  <Nav.Link
                    className={activeLink === "/game-providers" ? "active" : ""}
                    onClick={() => handleNavClick("/game-providers")}
                    as={Link}
                    to={"/game-providers"}>
                    Game Providers
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(58) ? (
                  <Nav.Link
                    className={activeLink === "/game-rate" ? "active" : ""}
                    onClick={() => handleNavClick("/game-rate")}
                    as={Link}
                    to={"/game-rate"}>
                    Game Rate
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(58) ? (
                  <Nav.Link
                    className={
                      activeLink === "/matka-bid-history" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/matka-bid-history")}
                    as={Link}
                    to={"/matka-bid-history"}>
                    Bid History
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(58) ? (
                  <Nav.Link
                    className={
                      activeLink === "/matka-bid-cutting" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/matka-bid-cutting")}
                    as={Link}
                    to={"/matka-bid-cutting"}>
                    Bid Cutting
                  </Nav.Link>
                ) : (
                  <></>
                )}{" "}
                {isAllow?.includes(59) ? (
                  <Nav.Link
                    className={activeLink === "/matka-result" ? "active" : ""}
                    onClick={() => handleNavClick("/matka-result")}
                    as={Link}
                    to={"/matka-result"}>
                    Results
                  </Nav.Link>
                ) : (
                  <></>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )} */}
        {/* {isAllow?.includes(60) ? (
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="7">
              <Accordion.Header
                onClick={() => handleNavClick("/notifications")}>
                <GiPokerHand size={22} className="me-2" />
                Teen Patti Management
              </Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={
                    activeLink === "/teen-patti-amount" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/teen-patti-amount")}
                  as={Link}
                  to={"/teen-patti-amount"}>
                  Teen Patti Amount
                </Nav.Link>
                <Nav.Link
                  className={
                    activeLink === "/teen-patti-history" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/teen-patti-history")}
                  as={Link}
                  to={"/teen-patti-history"}>
                  Teen Patti History
                </Nav.Link>{" "}
                <Nav.Link
                  className={
                    activeLink === "/teen-patti-history-room-wise"
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    handleNavClick("/teen-patti-history-room-wise")
                  }
                  as={Link}
                  to={"/teen-patti-history-room-wise"}>
                  Teen Patti History Room Wise
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <></>
        )} */}
        {/* {isAllow?.includes(61) || isAllow?.includes(62) ? ( */}
        <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
          <Accordion.Item eventKey="8">
            <Accordion.Header onClick={() => handleNavClick("/notifications")}>
              <FontAwesomeIcon icon={faDice} className="me-2" />
              Jackpot Rummy Management
            </Accordion.Header>
            <Accordion.Body>
              {isAllow?.includes(61) ? (
                <Nav.Link
                  className={activeLink === "/rummy-amount" ? "active" : ""}
                  onClick={() => handleNavClick("/rummy-amount")}
                  as={Link}
                  to={"/rummy-amount"}>
                  Rummy Amount
                </Nav.Link>
              ) : (
                <></>
              )}
              {isAllow?.includes(62) ? (
                <Nav.Link
                  className={
                    activeLink === "/rummy-table-points" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/rummy-table-points")}
                  as={Link}
                  to={"/rummy-table-points"}>
                  Rummy Table Points
                </Nav.Link>
              ) : (
                <></>
              )}

              {isAllow?.includes(62) ? (
                <Nav.Link
                  className={activeLink === "/rummy-history" ? "active" : ""}
                  onClick={() => handleNavClick("/rummy-history")}
                  as={Link}
                  to={"/rummy-history"}>
                  Rummy Game History
                </Nav.Link>
              ) : (
                <></>
              )}

              {isAllow?.includes(62) ? (
                <Nav.Link
                  className={
                    activeLink === "/rummy-table-history" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/rummy-table-history")}
                  as={Link}
                  to={"/rummy-table-history"}>
                  Rummy Table History
                </Nav.Link>
              ) : (
                <></>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {/* ) : (
          <></>
        )} */}

        <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
          <Accordion.Item eventKey="9">
            <Accordion.Header onClick={() => handleNavClick("/notifications")}>
              <FontAwesomeIcon icon={faDice} className="me-2" />
              Points Rummy Management
            </Accordion.Header>
            <Accordion.Body>
              {isAllow?.includes(62) ? (
                <Nav.Link
                  className={
                    activeLink === "/rummy-points-master" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/rummy-points-master")}
                  as={Link}
                  to={"/rummy-points-master"}>
                  Rummy Points Master
                </Nav.Link>
              ) : (
                <></>
              )}{" "}
              {isAllow?.includes(62) ? (
                <Nav.Link
                  className={
                    activeLink === "/points-rummy-history" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/points-rummy-history")}
                  as={Link}
                  to={"/points-rummy-history"}>
                  Points Rummy History
                </Nav.Link>
              ) : (
                <></>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Nav>
    </section>
  );
}

export default Sidebar;
